import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DateHelperService } from '@shared/services/date-helper.service';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {
  ProductDiscussion,
  ProductDiscussionData,
  ProductDiscussionReplyData,
} from '../interfaces/product-discussion.interface';

const guestApiUrl = environment.apiUrl + 'guest/products/';
const userApiUrl = environment.apiUrl + 'user/';

@Injectable({
  providedIn: 'root',
})
export class ProductDiscussionService {
  constructor(
    private http: HttpClient,
    private dateHelper: DateHelperService
  ) {}

  getProductDiscussions(
    productSlug: string,
    itemPerPage: number,
    currentPage: number
  ) {
    return this.http
      .post(guestApiUrl + 'discussions/' + productSlug, {
        item_per_page: itemPerPage,
        current_page: currentPage,
        sorts: [{ field: 'created_at', direction: 'DESC' }],
      })
      .pipe(
        map((res: any) => {
          let productDiscussionData: ProductDiscussionData = res.data;
          productDiscussionData.product_discussions.forEach((discussion) => {
            discussion.formattedTimeStamp =
              this.dateHelper.idTimeStampFormatter(discussion.created_at);
          });
          productDiscussionData.product_discussions =
            productDiscussionData.product_discussions.sort((a, b) => {
              return (
                new Date(b.created_at).getTime() -
                new Date(a.created_at).getTime()
              );
            });
          return productDiscussionData;
        })
      );
  }

  getProductDiscussionReplies(
    discussionId: number,
    itemPerPage: number,
    currentPage: number
  ) {
    return this.http
      .post(guestApiUrl + 'discussion_replies/' + discussionId, {
        item_per_page: itemPerPage,
        current_page: currentPage,
      })
      .pipe(
        map((res: any) => {
          let discussionReplyData: ProductDiscussionReplyData = res.data;
          discussionReplyData.product_discussion_replies.forEach((reply) => {
            reply.formattedTimeStamp = this.dateHelper.idTimeStampFormatter(
              reply.created_at
            );
          });
          return discussionReplyData;
        })
      );
  }

  addProductDiscussion(productId: number, discussion: string) {
    return this.http
      .post(userApiUrl + 'product_discussion', {
        product_id: productId,
        discussion: discussion,
      })
      .pipe(
        map((data: any) => {
          let newDiscussion: ProductDiscussion = data.data;
          newDiscussion.formattedTimeStamp =
            this.dateHelper.idTimeStampFormatter(newDiscussion.created_at);
          return newDiscussion;
        })
      );
  }

  addProductDiscussionReply(
    productId: number,
    parentId: number,
    discussion: string
  ) {
    return this.http
      .post(userApiUrl + 'product_discussion', {
        product_id: productId,
        parent_id: parentId,
        discussion: discussion,
      })
      .pipe(
        map((data: any) => {
          let newReply: ProductDiscussion = data.data;
          newReply.formattedTimeStamp = this.dateHelper.idTimeStampFormatter(
            newReply.created_at
          );
          return newReply;
        })
      );
  }
}
